import { useSplitTreatments } from "@splitsoftware/splitio-react";

export const CLAIM_BUSINESS = "claim_business";

type NameType = string | string[];

type ReturnType<T> = T extends string
  ? boolean
  : T extends string[]
    ? boolean[]
    : never;

export default function useFeatureFlag<T extends NameType>(
  featureFlagNames: T
): ReturnType<T> {
  const names: string[] =
    typeof featureFlagNames === "string"
      ? [featureFlagNames]
      : featureFlagNames;
  const { treatments, isReady } = useSplitTreatments({ names });
  const featureFlagStates = names.map(
    (name) => isReady && treatments[name]?.treatment === "on"
  );

  return (
    typeof featureFlagNames === "string"
      ? featureFlagStates[0]
      : featureFlagStates
  ) as ReturnType<T>;
}
